"use client";

import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HealthyAgeing() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };
  return <section id="vo2maxhealthyageing" data-nav="light" className="relative bg-background text-foreground border-b border-border py-20 md:py-28 overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-50px"
      }} className="flex flex-col items-start">
          <motion.h2 variants={itemVariants} className="text-3xl sm:text-4xl md:text-5xl font-default font-semibold tracking-tight text-foreground">
            VO<sub>2</sub> Max and healthy ageing
          </motion.h2>

          <motion.div variants={itemVariants} className="w-16 h-1 bg-primary/80 rounded-full mt-6 mb-8" aria-hidden="true" />

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-foreground font-medium leading-relaxed max-w-3xl mb-6">
            Cardiorespiratory fitness is an important marker of physical capacity and is strongly associated with long-term health outcomes in population research.
          </motion.p>

          <motion.p variants={itemVariants} className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-3xl mb-10">
            VO<sub>2</sub> Max testing does not predict an individual's lifespan, but it provides an objective measure that can be monitored and improved through appropriate exercise.
          </motion.p>

          <motion.div variants={itemVariants}>
            <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium px-6 py-3 rounded-md shadow-xs group">
              <Link to="#">
                <span>Longevity &amp; Fitness</span>
                <ArrowRight className="size-4 ml-1 transition-transform group-hover:translate-x-0.5" />
              </Link>
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}